// AdminOrderForm.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminAddOrder.css'; // optional styling
import {allAdminProductsURL,addOrderURL, mainImageURI} from '../assets/constants/Urls/Url';
import { useNavigate } from 'react-router-dom';
//import {ActivityIndicator} from 'react-native'; // optional loading indicator


const AdminAddOrder = () => {
  const [customerName, setCustomerName] = useState('');
  const [orderDate, setOrderDate] = useState(new Date().toISOString().slice(0, 10));
  const [address, setAddress] = useState('');
  const [contact, setContact] = useState('');
  const navigate = useNavigate()
  const [submitting, setSubmitting] = useState(false); // Loading state
  const [items, setItems] = useState([
    {
    name: '', 
    price: '', 
    quantity: 1 
    }
  ]);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [products, setProducts] = useState([]); // State to hold products
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [total, setTotal] = useState(0); // State to hold total amount

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;
    setItems(updatedItems);
  };

  const addItem = () => {
    setItems([...items, { name: '', price: '', quantity: 1 }]);
  };

  const removeItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };


  useEffect(() => {
    const calculatedTotal = items.reduce((acc, item) => {
      return acc + parseFloat(item.price) * parseInt(item.quantity);
    }, 0);
    setTotal(calculatedTotal);
  }, [items]);


  useEffect(() => {
        axios.get(allAdminProductsURL) // Fetch products from your backend
        .then((response) => {
            setProducts(response.data); // Set products to state
            setIsLoading(false); // Set loading to false after fetching
            //console.log('Products fetched:', response.data); // Log the products

        }).catch((error) => {
            console.error('Error fetching products:', error);
            setError('Failed to load products.');
        }
        )
        }, []); // Placeholder for any side effects

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true); // Set loading to true when submitting
    const order = {
        billingInfo: {
            name: customerName,
            address: address,
            contact: contact,
        },
        
        shippingMethod: 'Delivery',
        date: orderDate,
        totalAmount:total,
        cartItems: items.map(item => ({
            product_id: item.id,
            product_name: item.name,
            price: parseFloat(item.price),
            quantity: parseInt(item.quantity),
            total_price: parseFloat(item.price) * parseInt(item.quantity)

        }))
    };

    try {
      const response = await axios.post(addOrderURL, order);
      setMessage('Order created successfully!');
      setCustomerName('');
      setItems([{ name: '', price: '', quantity: 1 }]);
      navigate('../')
      setSubmitting(false); // Set loading to false after submission
    
    } catch (error) {
      console.error('Error creating order:', error);
      setMessage('Failed to create order.');
    }

    finally {
        setSubmitting(false); // Set loading to false after submission
    }
  };

  return (
    <div className="container my-4">
      <h2>Create New Order</h2>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Customer Name</label>
          <input
            type="text"
            className="form-control"
            placeholder='Enter Customer Name'
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Addres</label>
          <input
            type="text"
            className="form-control"
            placeholder='Enter Address'
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
        <label className="form-label">Contact</label>
        <div className='input-group'>
            <span id='lbr-code' className='input-group-text'>+231</span>
            <input
                type="tel"
                className="form-control"
                placeholder="Enter Contact"
                value={contact.replace('+231', '')}
                onChange={(e) => {
                    let input = e.target.value.replace(/\D/g, '');
                    if (input.startsWith('0')) {
                    input = input.slice(1);
                    }
                    setContact('+231' + input);
                }}
                required
                minLength={7}
                maxLength={10}
                />
        </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Order Date</label>
          <input
            type="date"
            className="form-control"
            value={orderDate}
            onChange={(e) => setOrderDate(e.target.value)}
            required
          />
        </div>

        <h5>Products</h5>
        {items.map((item, index) => (
          <div className="row mb-3 align-items-end" key={index}>
            <div className="col-md-4">
                {items && (
                    <img
                        src={`${mainImageURI}${String(item.id + "_" + 0)}/${item.id}`}
                        alt={item.name}
                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                        
                        crossOrigin="anonymous"
                    />
                    
                )}
                <input
                    list="product-options"
                    className="form-control"
                    placeholder="Product Name"
                    value={item.name}
                    onChange={(e) =>{
                        const selectedName = e.target.value ;
                        const foundProduct = products.find(prod => prod.name === selectedName);
                    
                        const updatedItems = [...items];
                        if (foundProduct) {
                          updatedItems[index].name = foundProduct.name;
                          updatedItems[index].id = foundProduct.id;
                          updatedItems[index].price = foundProduct.price; // optional, auto-fill price if you want
                        } else {
                          updatedItems[index].name = selectedName;
                          updatedItems[index].id = null;
                          updatedItems[index].price = '';
                        }
                        setItems(updatedItems);
                    }}
                    required
                />
                <datalist id="product-options">
                    {products.map((product, idx) => (
                    <option key={idx} value={product.name} />
                    ))}
                </datalist>
            </div>

            <div className="col-md-3">
              <input
                type="number"
                className="form-control"
                placeholder="Price"
                value={item.price}
                onChange={(e) => handleItemChange(index, 'price', e.target.value)}
                required
              />
            </div>

            <div className="col-md-2">
              <input
                type="number"
                className="form-control"
                placeholder="Qty"
                value={item.quantity}
                onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                required
                min="1"
              />
            </div>

            <div className="col-md-2">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => removeItem(index)}
                disabled={items.length === 1}
              >
                Remove
              </button>
            </div>
          </div>
        ))}

        <button type="button" className="btn btn-secondary mb-3" onClick={addItem}>Add Another Product</button>


        <button type={submitting ? "" : "submit"} className="btn btn-primary">
        {submitting ? "Saving..." : "Save Order"}
        </button>
        
      </form>
    </div>
  );
};

export default AdminAddOrder;
